// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3is2x","name":"styles_name__3khB5","phone":"styles_phone__3A0LI"};